import { defineMessages } from 'react-intl'

const messages = defineMessages({
  clear: {
    id: 'link.clear',
  },
  apply: {
    id: 'button.apply',
  },
  sort: {
    id: 'global.order-by',
  },
  filter: {
    id: 'global.filters',
  },
})

export default messages
